import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PhoneCircleSVG = function PhoneCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.68,23.07l-.12,0L11.41,23l-.1-.05a.44.44,0,0,1-.14-.13l-.07-.06a1.05,1.05,0,0,1-.13-.26l-.92-2.7a.87.87,0,0,1,.41-1.05l2.92-1.55a.91.91,0,0,1,.36-.09h.1l.21,0,.09,0a1.06,1.06,0,0,1,.26.17l1.43,1.25a5.11,5.11,0,0,0,2.51-3.8l-1.64-1a.89.89,0,0,1-.36-1l1-3.1a.64.64,0,0,1,.15-.25.23.23,0,0,1,.07-.07l.14-.13.11,0A.76.76,0,0,1,18,9.07l.12,0,.22,0,2.87.4a.76.76,0,0,1,.71.75c.67,7-3.07,12.2-10,12.9A.74.74,0,0,1,11.68,23.07Z"
  }));
};
PhoneCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PhoneCircleSVG);